import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class RateLimitService implements OnDestroy {
    /** Seconds remaining until requests are allowed again (0 = not throttled) */
    readonly remaining$ = new BehaviorSubject<number>(0);
    private timer: any;

    startFromHeaders(headers: HttpHeaders | any, fallbackSeconds = 10) {
        const ra = headers?.get?.('Retry-After') ?? headers?.['Retry-After'];
        let secs = parseInt(ra, 10);
        if (Number.isNaN(secs)) {
            const ms = Date.parse(ra || '') - Date.now();
            secs = ms > 0 ? Math.ceil(ms / 1000) : fallbackSeconds;
        }
        this.start(secs || fallbackSeconds);
    }

    start(seconds: number) {
        this.clear();
        const s = Math.max(0, Math.floor(seconds));
        this.remaining$.next(s);
        if (s === 0) return;
        this.timer = setInterval(() => {
            const next = Math.max(0, this.remaining$.value - 1);
            this.remaining$.next(next);
            if (next === 0) this.clear();
        }, 1000);
    }

    clear() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
    }

    get isThrottled(): boolean {
        return this.remaining$.value > 0;
    }

    ngOnDestroy() {
        this.clear();
    }
}
